import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconChevronRight = ({ ...props }: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path d="M7 4L13 10L7 16" stroke="#202723" strokeWidth="1.4" />
  </SvgIcon>
);
